module.exports = __webpack_public_path__ + "img/logo.abca0a5f.png";